module.exports = __webpack_public_path__ + "static/img/base_3.d86b87a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/base_3.jpg
// module id = DBHI
// module chunks = 1